// extracted by mini-css-extract-plugin
module.exports = {"modal_header":"tax-modal_modal_header__qnJEl","checkbox":"tax-modal_checkbox__KsecH","checkbox-label":"tax-modal_checkbox-label__VaNyx"};